import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

import Paragraph from '../Paragraph';

export default class ArticleBody extends Component {
  getContent() {
    return {
      '__html': this.props.content
    };
  }

  render() {
    let paragraphs = this.props.content.split(/\r?\n/);
    // <div className={css(styles.container)} dangerouslySetInnerHTML={this.getContent()} />

    return (
      <div className={css(styles.container) + ' article-body'}>
        {
          paragraphs && paragraphs.length ? paragraphs.map((paragraph, index) => {
            return (
              <Paragraph key={`paragraph_${index}`} htmlContent={paragraph} />
            );
          }) : (
            <div dangerouslySetInnerHTML={this.getContent()} />
          )
        }
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    width: '100%',
    margin: '0px auto',
    lineHeight: '24px',
  },
  '.article-body img': {
    maxWidth: '100%',
    height: 'auto',
  },
});



// WEBPACK FOOTER //
// ./src/components/ArticleBody/index.js